<div *ngIf="!configMode" class="non-config-mode-container">
    <p *ngIf="eventNotAvailable" class="the-event-is-no-longer-available">
        <span translate>THE_EVENT_IS_NO_LONGER_AVAILABLE</span>
    </p>
    <azavista3-apexcharts-wrapper *ngIf="definition.data" #displayModeChart [series]="series" [labels]="labels"
        [type]="chart.type" [width]="chart.width" [height]="chart.height"
        (dataPointSelected)="onDataPointSelected($event)">
    </azavista3-apexcharts-wrapper>
    <div *ngIf="isFieldRatingOrOpinionScale" class="rating-or-opinion-scale-container">
        <div>
            {{field.label}}
        </div>
        <div class="stars-container">
            <span *ngFor="let ratingIcon of ratingIcons">
                <mat-icon *ngIf="ratingIcon.isFull">star</mat-icon>
                <mat-icon *ngIf="ratingIcon.isHalf">star_half</mat-icon>
                <mat-icon *ngIf="ratingIcon.isEmpty">star_outline</mat-icon>
            </span>
        </div>
    </div>
</div>

<div *ngIf="configMode" class="config-mode-container">
    <div class="settings-container">
        <div class="setting-item">
            <div class="aza-pa-flex-row">
                <div *ngIf="event" class="aza-pa-flex-row">
                    <span translate>EVENT</span>:
                    <span>{{event.name}}</span>
                </div>
                <azavista-button *ngIf="!isEventPredefined" (click)="onSelectEvent()">
                    <span translate>SELECT_EVENT</span>
                </azavista-button>
            </div>
        </div>
        <div class="setting-item">
            <mat-form-field>
                <mat-select (selectionChange)="chartTypeChanged($event.value)"
                    [(value)]="definition.settings.local.chartType" placeholder="{{'CHART_TYPE' | translate}}">
                    <mat-option value='bar'>Bar</mat-option>
                    <mat-option value='donut'>Donut</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="setting-item">
            <ng-container *ngIf="enumTypeEventParticipantFields && groupByField && groupByFieldValue">
                <azavista-input-field (valueChanged)="onGroupByFieldChanged($event)" [field]="groupByField"
                    [value]="groupByFieldValue" [editMode]="true" [fullWidth]="false">
                </azavista-input-field>
            </ng-container>
        </div>
        <div class="setting-item">
            <azavista-flat-button *ngIf="enumTypeEventParticipantFields" (click)="onShowFilter()" [disabled]="!eventId" [matTooltip]="translations.PLEASE_SELECT_EVENT | translate" [matTooltipDisabled]="!!eventId">
                <span translate>FILTER</span>
            </azavista-flat-button>
        </div>
    </div>
</div>
